import request from '../request'
import qs from 'query-string'

// 获取字典列表
export function getDictCategoryList() {
    return request.get(`/api/dict/categories`)
}

// 获取字典类别列表分页
export function getDictCategoryListPage(params: any) {
    let query = qs.stringify(params)
    return request.get(`/api/dict/categories/page?${query}`)
}
//新增字典类别
export function addDictCategory(data: any) {
    return request.post(`/api/dict/categories`, data)
}

// 更新字典类别
export function updateDictCategory(data: any) {
    return request.put(`/api/dict/categories/${data.id}`, data)
}
// 删除字典类别
export function deleteDictCategory(id: string) {
    return request.delete(`/api/dict/categories/${id}`)
}


// 获取字典列表根据id
export function getDictListById(categoryId?: string | number) {
    return request.get(`/api/dict/items/category/${categoryId}`)
}

// 新增字典
export function addDict(data: any) {
    return request.post(`/api/dict/items`, data)
}



// 删除字典
export function deleteDict(id?: string | number) {
    return request.delete(`/api/dict/items/${id}`)
}

